import { QueryClient } from '@tanstack/react-query';

import { appConfig } from './appConfig';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: appConfig.http.get.refetchOnWindowFocus,
            retry: appConfig.http.get.retryCount,
        },
    },
});
